<template>
    <div v-if="isMounted">
        <v-app-bar :ref="appBar"
                   app
                   color="primary"
                   :dark="!isHideHero"
                   :extended="isHomePage && !isHeroHidden && !drawer"
                   :extension-height="isHomePage && !isHeroHidden ? display.mobile ? extensionHeightMobile : extensionHeight : 0"
                   scroll-threshold="1"
                   scroll-behavior="fully-hide"
                   :density="isHomePage && !isHeroHidden ? 'prominent' : 'compact'"
                   :image="isHeroHidden || drawer || !isHomePage ? '' : '/hero2.jpeg'"
                   class="align-items-center px-6">
            <div v-if="isHomePage && !isHeroHidden && !drawer && isMounted"
                 class="d-flex flex-row justify-center align-center title-centered">
                <div :class="[display.mobile ? 'text-body-1' : '', 'motto fading-background']"
                     :style="{ animationDelay: `${0.5}s` }">
                    <span v-for="(word, index) in mottoWords"
                          :key="index"
                          :style="{ animationDelay: `${index * 0.5}s` }"
                          :class="[display.mobile ? '' : 'mr-2', 'animate-word text-uppercase font-weight-bold']">
                        {{ word }}
                    </span>
                </div>
                <v-btn v-if="!display.mobile"
                       :class="[{ 'ml-2': isHideHero }, { 'schedule-btn': !isHideHero }, 'font-weight-bold']"
                       color="secondary"
                       style=""
                       variant="elevated"
                       size="large"
                       to="#contact-form">Schedule Consultation</v-btn>
            </div>
            <NuxtImg src="/logo_outline_dark.png"
                     :class="!isHomePage || (isHeroHidden || drawer) ? !isHeroHidden && !drawer ? 'darken-overlay logo_mobile_collapsed' : 'logo_mobile_collapsed' : 'logo'" />

            <!-- <v-app-bar-title class="font-weight-black">Elite Glazing Soutions LLC.</v-app-bar-title> -->
            <v-spacer />
            <div class="mr-4"
                 v-if="!display.mobile">
                <v-btn v-for="item in navOptions"
                       class="font-weight-bold justify-content-center align-center"
                       size="large"
                       variant="text"
                       :to="item.to"><v-icon class="mr-2 mb-1">{{ item.icon }}</v-icon>{{ item.text }}</v-btn>
            </div>
            <v-app-bar-nav-icon @click="drawer = !drawer"
                                location="right"
                                :class="[isHideHeroMobile ? 'mt-n14' : 'bg-primaryOverlay', 'font-weight-black text-h5']"
                                color="white"
                                v-else />
            <v-btn v-if="display.mobile && isMounted"
                   class="schedule-btn-mobile font-weight-bold text-primary bg-secondary"
                   block
                   variant="elevated"
                   to="#contact-form"
                   :density="display.mobile ? 'compact' : 'comfortable'"
                   :size="display.mobile ? 'large' : 'xlarge'">{{ actionButtonText }}</v-btn>

        </v-app-bar>

        <v-navigation-drawer v-if="isMounted"
                             v-model="isShowDrawer"
                             app
                             persistent
                             eager
                             location="bottom">
            <v-list>
                <v-list-item v-for="(item, index) in navOptions"
                             :key="index"
                             class="font-weight-bold justify-content-center align-center"
                             :to="item.to">
                    <v-list-item-title><v-icon class="mr-2 mb-1">{{ item.icon }}</v-icon>{{ item.text
                        }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onBeforeUnmount, ref } from 'vue';
import { useDisplay } from 'vuetify';
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import ContactForm from './contactForm.vue';

const route = useRoute();

const mottoWords = ref(['Bringing', 'beauty', 'and', 'functionality', 'to', 'your', 'projects.']);
const actionButtonText = computed(() => (display.value.mobile ? 'Schedule Now' : 'Schedule your consultation'));
const navOptions = ref([
    { text: 'Home', icon: 'mdi-home', to: { path: "/" } },
    { text: 'Portfolio', icon: 'mdi-image', to: { path: "/portfolio" } },
    // { text: 'About', icon: 'mdi-account', to: { path: "/about" } },
    { text: 'Contact', icon: 'mdi-book', to: { path: "/", hash: "#contact-form" } }
]);
const appBar = ref();
const display = ref(useDisplay());
const drawer = ref(false);
const isHideHero = ref(false);
const isMounted = ref(false);
const isHideHeroMobile = ref(false);
const isHomePage = ref(false);
const appBarHeight = 300;
const appBarHeightMobile = 250;

const extensionHeight = computed(() => {
    return !isHideHero.value ? appBarHeight : 0;
});

const extensionHeightMobile = computed(() => {
    return isHideHeroMobile.value ? 0 : appBarHeightMobile;
});

const isShowDrawer = computed(() => {
    return (display.value.mobile && drawer.value) ||
        false;
});

const isHeroHidden = computed(() => {
    return isHideHero.value || isHideHeroMobile.value;
});

watch(() => route.fullPath, (newPath, oldPath) => {
    const isContactForm = newPath.includes("#contact-form");
    isHomePage.value = newPath === '/' || isContactForm;

    if (isContactForm) {
        setTimeout(() => {
            const contactForm = document.querySelector('#contact-form');
            if (contactForm) {
                contactForm.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    }
}, { immediate: true });

onMounted(() => {
    if (isHomePage.value)
        handleScroll();
    isMounted.value = true;
});

onBeforeMount(() => {
    if (!isHomePage.value)
        return;
    window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll);
});

function handleScroll() {
    const isScrolled = window.scrollY > 0;
    if (display.value.mobile) {
        isHideHeroMobile.value = isScrolled;
    } else {
        isHideHero.value = isScrolled;
    }
}
</script>
<style lang="css" scoped>
.logo {
    position: fixed;
    height: -moz-max-content;
    height: max-content;
    max-width: 539px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    background-color: #00000047;
    opacity: 0;
    animation: fadeIn 1.5s ease-in-out forwards;
}

.title-centered {
    position: fixed;
    display: flex;
    flex-direction: row;
    min-width: max-content;

    top: 75%;
    left: 50%;
    transform: translate(-50%, -30%);
    text-align: center;
    z-index: 5;
}

.motto {
    font-size: 30px;
    /* background-color: #00000061; */
    font-weight: bold;
    text-transform: uppercase;
    padding: 5px 15px;
    border-radius: 5px;
    transform: translate(25%, 25%);
    z-index: 5;
}

.animate-word {
    padding: 2px 5px;
    opacity: 0;
    animation: fadeInWord 2s linear forwards;
}

.schedule-btn-mobile {
    position: fixed;
    left: 100%;
    top: 100%;
    opacity: 0;
    animation: slideInFromLeftMobile 1.5s linear forwards;
    animation-delay: 1.5s;
}

.schedule-btn {
    color: var(--v-primary);
    right: -100%;
    width: 525px;
    opacity: 0;
    transform: translate(-98%, 30%);
    animation: slideInFromLeft 2s ease-in-out forwards;
    animation-delay: 3.5s;
    z-index: 10;
}

.fading-background {
    width: 100%;
    height: 50px;
    animation: fadeBackground 4s alternate ease-in-out;
}

@keyframes fadeBackground {
    0% {
        background: linear-gradient(to right, #00000061 0%, transparent 100%);
    }

    100% {
        background: linear-gradient(to right, transparent 0%, #00000061 100%);
    }
}

@keyframes fadeIn {
    0% {
        left: 0%;
        opacity: 0;
    }

    100% {
        left: 50%;
        opacity: 1;
    }
}

@keyframes fadeInWord {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }

    50% {
        opacity: 1;
        transform: translateY(0px);
    }

    100% {
        opacity: 0;
        transform: translateY(0);
    }
}

@keyframes slideInFromLeft {
    0% {
        right: -100%;
        opacity: 0;
    }

    100% {
        right: 0%;
        opacity: 1;
    }
}

@keyframes slideInFromLeftMobile {
    0% {
        left: -100%;
        opacity: 0;
    }

    100% {
        left: 0%;
        opacity: 1;
    }
}

.darken-overlay {
    background-color: #0000005e;
}

.logo_mobile_collapsed {
    position: initial;
    height: -moz-max-content;
    height: max-content;
    max-width: 250px;
    margin-top: 10px;
    border-radius: 10px;
}

:deep(.v-toolbar__content) {
    min-height: 110px !important;
}

@media screen and (max-width: 1200px) {
    :deep(.v-toolbar__content) {
        min-height: 110px !important;
    }

    .motto {
        top: 85%;
        left: 45%;
        text-transform: capitalize;
        transform: none;
    }

    .title-centered {
        top: 96%;
        left: 50%;
    }

    .fading-background {
        height: 30px;
    }
}

@media screen and (max-width: 600px) {
    .motto {
        font-size: 12px !important;
        top: 85%;
        left: 45%;
    }

    .fading-background {
        width: 95%;
        height: 30px;
    }

    .animate-word {
        padding: 2px 2px;
    }
}
</style>